export default "__VITE_ASSET__4df2e92e__"